import * as React from 'react';

const SvgHighlights3 = (props) => (
  <svg width={528} height={257} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M528 128.499c-145.923 171.335-382.077 171.335-528 0 145.916-171.332 382.077-171.332 528 0Z"
      fill="url(#highlights-3big_svg__a)"
    />
    <circle cx={264} cy={128} r={107} fill="#F6F6F6" />
    <path
      d="m312.955 73.425-44.968-18.628a10.333 10.333 0 0 0-7.958 0l-44.976 18.628a10.316 10.316 0 0 0-5.629 5.624l-18.627 44.97a10.348 10.348 0 0 0 0 7.962l18.627 44.97a10.316 10.316 0 0 0 5.629 5.624l44.968 18.628a10.334 10.334 0 0 0 7.958 0l44.968-18.628a10.38 10.38 0 0 0 3.38-2.249 10.39 10.39 0 0 0 2.249-3.375l18.627-44.97a10.334 10.334 0 0 0 0-7.958l-18.627-44.974a10.327 10.327 0 0 0-5.621-5.624Zm-6.903 101.201-39.547 16.378-16.379-39.548 39.568-16.379 16.358 39.549ZM217.37 85.941l39.547 16.378-16.378 39.549-39.548-16.379 16.379-39.548Zm71.006 38.066a9.089 9.089 0 0 0-.32.891l-35.804 14.829 14.832-35.802c.299-.096.595-.199.891-.319l34.826-14.426-14.425 34.827Zm-24.224-60.002 35.585 14.741-35.901 14.873c-.291.12-.579.255-.859.4l-35.796-14.83 36.659-15.18a.398.398 0 0 1 .324.012l-.012-.016Zm-45.284 109.33a.399.399 0 0 1-.22-.224l-14.741-35.585 35.741 14.804 14.809 35.746-35.589-14.741Zm109.103-45.509a.393.393 0 0 1 0 .316l-15.18 36.66-14.828-35.801c.144-.28.28-.563.4-.859l14.868-35.902 14.74 35.586Z"
      fill="#807e7e"
    />
    <defs>
      <linearGradient
        id="highlights-3big_svg__a"
        x1={111.643}
        y1={46.567}
        x2={656.412}
        y2={337.155}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#F6F6F6" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgHighlights3;
